// Granite Peak Manufacturing - Feeds & Speeds Calculator page logic
(function (global) {
'use strict';
var GPM = global.GPM;

var state = {
  mode: 'milling',
  milling: { materialName: '', customMaterial: null, operationType: 'General Milling', strategyMode: 'Balanced', toolDiameter: '', fluteCount: '', toolMaterial: 'Carbide', coating: 'Uncoated', stickout: '', radialEngagement: '50', axialDepth: '' },
  drilling: { materialName: '', customMaterial: null, drillOperationType: 'Standard Drill', drillStrategyMode: 'Balanced', toolDiameter: '', toolMaterial: 'Carbide', coating: 'Uncoated', holeDepth: '', pointAngle: '118' },
  tapping: { materialName: '', customMaterial: null, tapMajorDiameter: '', threadPitch: '', threadEngagement: '65', holeDepth: '', tapMaterial: 'HSS', tappingStrategy: 'Balanced' }
};

function normalizedCustomMaterials() {
  return GPM.getCustomMaterials().map(function (m) {
    return {
      name: m.name,
      category: m.category || 'Custom',
      hardnessHB: m.hardness_hb,
      tensileUTS: m.tensile_uts,
      sfmBase: parseFloat(m.sfm_base) || 300,
      chipLoadBase: parseFloat(m.chip_load_base) || 0.002
    };
  });
}

function availableMaterials() {
  return normalizedCustomMaterials().concat(GPM.MATERIAL_LIBRARY);
}

function machineSetups() { return GPM.getMachineSetups(); }

function selectedMachine() {
  var id = GPM.getActiveMachineId();
  var machines = machineSetups();
  return machines.find(function (m) { return m.id === id; }) || null;
}

function fillMaterialSelect() {
  var sel = document.getElementById('gpm-material');
  var current = state[state.mode].materialName;
  var mats = availableMaterials();
  var cats = [];
  mats.forEach(function (m) { if (cats.indexOf(m.category) === -1) cats.push(m.category); });
  var html = '<option value="">Select material...</option>';
  cats.forEach(function (cat) {
    html += '<optgroup label="' + GPM.esc(cat) + '">';
    mats.filter(function (m) { return m.category === cat; }).forEach(function (m) {
      html += '<option value="' + GPM.esc(m.name) + '">' + GPM.esc(m.name) + '</option>';
    });
    html += '</optgroup>';
  });
  sel.innerHTML = html;
  sel.value = current || '';
}

function fillMachineSelect() {
  var sel = document.getElementById('gpm-machine');
  var machines = machineSetups();
  var activeId = GPM.getActiveMachineId();
  if (!activeId || !machines.some(function (m) { return m.id === activeId; })) {
    activeId = machines[0] ? machines[0].id : '';
    GPM.setActiveMachineId(activeId);
  }
  if (machines.length === 0) {
    sel.innerHTML = '<option value="">No machine setups available</option>';
    sel.disabled = true;
  } else {
    sel.innerHTML = machines.map(function (m) {
      return '<option value="' + GPM.esc(m.id) + '">' + GPM.esc(m.name) + '</option>';
    }).join('');
    sel.disabled = false;
    sel.value = activeId;
  }
}

function renderMachinePanel() {
  var el = document.getElementById('gpm-machine-panel');
  var m = selectedMachine();
  if (!m) {
    el.innerHTML = '<p class="gpm-mono" style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--shop-light);margin:0;">No machine selected. Choose one from the calculator dropdown or manage machines in Setups.</p>';
    return;
  }
  var maxIpm = m.maxIpm || m.maxFeedrate || '—';
  function cell(k, v) {
    return '<div><span class="gpm-mono" style="color:var(--shop-mid);text-transform:uppercase;letter-spacing:.1em;font-size:9px;">' + k + '</span><p style="color:var(--shop-silver);margin:2px 0 0;font-size:13px;">' + GPM.esc(v || '—') + '</p></div>';
  }
  el.innerHTML = '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">'
    + cell('Name', m.name) + cell('Max RPM', m.maxRpm) + cell('Max IPM', maxIpm) + cell('Spindle HP', m.spindlePower) + '</div>';
}

function unitLabels() {
  var unit = GPM.currentUnit();
  return {
    len: unit === 'metric' ? 'mm' : 'in',
    feed: unit === 'metric' ? 'mm/min' : 'ipm',
    mrr: unit === 'metric' ? 'cm³/min' : 'in³/min',
    chip: unit === 'metric' ? 'mm/t' : 'in/t',
    fpr: unit === 'metric' ? 'mm/rev' : 'in/rev',
    torque: unit === 'metric' ? 'N·m' : 'in-lb'
  };
}

function applyUnitLabels() {
  var u = unitLabels();
  document.querySelectorAll('[data-unit-label="len"]').forEach(function (el) { el.textContent = u.len; });
  var ph = GPM.currentUnit() === 'metric';
  var map = {
    'toolDiameter': ph ? '12' : '0.5', 'stickout': ph ? '38' : '1.5', 'axialDepth': ph ? '6' : '0.25',
    'drill-toolDiameter': ph ? '12' : '0.5', 'drill-holeDepth': ph ? '25' : '1.0',
    'tapMajorDiameter': ph ? '6.35' : '0.25', 'threadPitch': ph ? '1.27' : '0.05', 'tap-holeDepth': ph ? '12' : '0.5'
  };
  Object.keys(map).forEach(function (id) {
    var el = document.getElementById('gpm-' + id);
    if (el) el.placeholder = map[id];
  });
}

function setMode(mode) {
  state.mode = mode;
  document.querySelectorAll('[data-mode-btn]').forEach(function (b) {
    b.classList.toggle('active', b.getAttribute('data-mode-btn') === mode);
  });
  ['milling', 'drilling', 'tapping'].forEach(function (m) {
    var el = document.getElementById('gpm-form-' + m);
    if (el) el.style.display = m === mode ? '' : 'none';
  });
  fillMaterialSelect();
  compute();
}

function bindInput(id, mode, field) {
  var el = document.getElementById('gpm-' + id);
  if (!el) return;
  el.addEventListener('input', function () {
    state[mode][field] = el.value;
    compute();
  });
  el.addEventListener('change', function () {
    state[mode][field] = el.value;
    compute();
  });
}

function dro(label, value, unit) {
  var v = (value === null || value === undefined || value === '' || Number.isNaN(value)) ? '---' : value;
  if (v === 0) v = '---';
  return '<div class="dro-readout-panel"><div class="dro-label">' + label + '</div>'
    + '<div class="dro-value-row"><span class="dro-value">' + GPM.esc(v) + '</span>'
    + (unit ? '<span class="dro-unit">' + unit + '</span>' : '') + '</div></div>';
}

function row(k, v) {
  return '<div class="row"><span class="k">' + k + '</span><span class="v">' + v + '</span></div>';
}

function compute() {
  var unit = GPM.currentUnit();
  var machine = selectedMachine();
  var mode = state.mode;
  var values = state[mode];

  // resolve custom material object
  var custom = normalizedCustomMaterials().find(function (m) { return m.name === values.materialName; }) || null;
  values.customMaterial = custom;

  var results = null;
  if (mode === 'milling') results = GPM.runCalculations(values, unit, machine);
  else if (mode === 'drilling') results = GPM.runDrillingCalculations(values, unit, machine);
  else results = GPM.runTappingCalculations(values, unit, machine);

  renderResults(results);
  renderMachinePanel();
}

function renderResults(results) {
  var u = unitLabels();
  var mode = state.mode;
  var el = document.getElementById('gpm-results');
  var html = '';

  html += dro('Surface Speed', results ? results.sfm : null, 'sfm');
  html += dro('Spindle Speed', results ? results.rpm : null, 'rpm');
  html += dro('Feed Rate', results ? results.feedIpm : null, u.feed);
  if (mode === 'milling') {
    html += dro('Chip Thickness', results ? results.chipThickness : null, u.chip);
  } else if (mode === 'drilling') {
    html += dro('Feed per Revolution', results ? results.feedPerRev : null, u.fpr);
    html += dro('Peck Distance', results ? results.peckDistance : null, u.len);
  } else {
    html += dro('Tap Drill Size', results ? results.tapDrillDiameter : null, u.len);
    html += dro('Feed per Revolution', results ? results.feedPerRev : null, u.fpr);
    html += dro('Tap Torque', results ? results.torque : null, u.torque);
    html += dro('Tap Shear Stress', results ? results.shearStress : null, 'ksi');
    html += dro('Safety Factor', results ? results.safetyFactor : null, 'x');
  }
  html += dro('Material Removal Rate', results ? results.mrr : null, u.mrr);
  html += dro('Est. Cutting Power', results ? results.hp : null, 'HP');

  var wrap = '<div class="gpm-stack-lg">' + html + '</div>';

  if (results) {
    var d = '';
    d += row('Strategy', GPM.esc(results.strategyMode || ''));
    d += row('Machine', GPM.esc(results.machineName || 'Not selected'));
    d += row('Operation', GPM.esc(results.operationType || ''));
    if (mode === 'milling') {
      d += row('Radial WOC', (results.ae != null ? results.ae.toFixed(3) : '—') + ' ' + u.len);
      d += row('Axial DOC', (results.ap != null ? results.ap.toFixed(3) : '—') + ' ' + u.len);
      d += row('Governing Limit', GPM.esc(results.governingLimit || ''));
      d += row('Deflection Used', GPM.esc(results.estimatedDeflection) + ' / ' + GPM.esc(results.allowableDeflection) + ' ' + u.len);
    } else if (mode === 'drilling') {
      d += row('Hole Depth', (results.holeDepth != null ? results.holeDepth.toFixed(3) : '—') + ' ' + u.len);
      d += row('Point Angle', GPM.esc(results.pointAngle) + '°');
    } else {
      d += row('Thread Engagement', GPM.esc(results.threadEngagement) + '%');
      d += row('Hole Depth', (results.holeDepth != null ? results.holeDepth.toFixed(3) : '—') + ' ' + u.len);
      d += row('Tap Material', GPM.esc(results.tapMaterial));
    }

    var alerts = '';
    if (results.powerCurveLimited) {
      alerts += '<div class="gpm-alert gpm-alert-red"><p class="alert-title">Power Curve Limit Active</p><p>Feed reduced to stay within available spindle power (' + GPM.esc(results.availableHp) + ' HP at current RPM).</p></div>';
    }
    if (results.limits && results.limits.isLimited) {
      alerts += '<div class="gpm-alert gpm-alert-yellow"><p class="alert-title">Machine Limit Active</p>'
        + (results.limits.rpmCapped ? '<p>• RPM capped to machine limit</p>' : '')
        + (results.limits.ipmCapped ? '<p>• Feed rate capped to machine limit</p>' : '') + '</div>';
    }
    if (mode === 'tapping' && results.warnings && results.warnings.length) {
      alerts += '<div class="gpm-alert gpm-alert-red"><p class="alert-title">Tapping Risk Warnings</p>'
        + results.warnings.map(function (w) { return '<p>• ' + GPM.esc(w) + '</p>'; }).join('') + '</div>';
    }
    if (mode === 'milling' && results.roughingSuggestions && results.roughingSuggestions.length) {
      alerts += '<div class="gpm-alert gpm-alert-blue"><p class="alert-title">Adaptive Roughing Optimizer</p>'
        + results.roughingSuggestions.map(function (r, i) {
            return '<p>#' + (i + 1) + ' — ae ' + r.ae + ' ' + u.len + ' (' + r.radialPct + '%), ap ' + r.ap + ' ' + u.len + ', ' + r.feed + ' ' + u.feed + ', ' + r.rpm + ' rpm, ' + r.mrr + ' ' + u.mrr + '</p>';
          }).join('') + '</div>';
    }
    wrap += '<div class="gpm-detail-rows">' + d + alerts + '</div>';
  } else {
    wrap += '<div class="gpm-hint">Select a material &amp; enter tool parameters</div>';
  }

  el.innerHTML = wrap;
}

function importFromQuery() {
  var params = new URLSearchParams(global.location.search);
  var material = params.get('material');
  var tool = params.get('tool');
  var notes = params.get('notes');
  if (!material && !tool && !notes) return;

  var diameterMatch = (tool || '').match(/(\d+(?:\.\d+)?)\s*(?:mm|in|")?/i);
  var fluteMatch = (tool || '').match(/(\d+)\s*(?:fl|flute)/i);
  var toolDiameter = diameterMatch ? diameterMatch[1] : '';
  var fluteCount = fluteMatch ? fluteMatch[1] : '';

  if (material) {
    state.milling.materialName = material;
    state.drilling.materialName = material;
    state.tapping.materialName = material;
  }
  if (toolDiameter) {
    state.milling.toolDiameter = toolDiameter;
    state.drilling.toolDiameter = toolDiameter;
    state.tapping.tapMajorDiameter = toolDiameter;
  }
  if (fluteCount) state.milling.fluteCount = fluteCount;

  if (notes) {
    var noteEl = document.getElementById('gpm-imported-notes');
    if (noteEl) {
      noteEl.textContent = 'Imported setup notes: ' + notes;
      noteEl.style.display = '';
    }
  }

  // reflect into inputs
  var ids = { 'toolDiameter': state.milling.toolDiameter, 'fluteCount': state.milling.fluteCount, 'drill-toolDiameter': state.drilling.toolDiameter, 'tapMajorDiameter': state.tapping.tapMajorDiameter };
  Object.keys(ids).forEach(function (id) {
    var el = document.getElementById('gpm-' + id);
    if (el && ids[id]) el.value = ids[id];
  });

  params.delete('material'); params.delete('tool'); params.delete('notes');
  var next = params.toString();
  global.history.replaceState({}, '', global.location.pathname + (next ? '?' + next : ''));
}

document.addEventListener('DOMContentLoaded', function () {
  fillMachineSelect();
  fillMaterialSelect();
  applyUnitLabels();
  importFromQuery();

  document.getElementById('gpm-material').addEventListener('change', function (e) {
    state[state.mode].materialName = e.target.value;
    compute();
  });
  document.getElementById('gpm-machine').addEventListener('change', function (e) {
    GPM.setActiveMachineId(e.target.value);
    compute();
  });
  document.querySelectorAll('[data-mode-btn]').forEach(function (b) {
    b.addEventListener('click', function () { setMode(b.getAttribute('data-mode-btn')); });
  });

  // milling bindings
  bindInput('toolDiameter', 'milling', 'toolDiameter');
  bindInput('fluteCount', 'milling', 'fluteCount');
  bindInput('stickout', 'milling', 'stickout');
  bindInput('toolMaterial', 'milling', 'toolMaterial');
  bindInput('coating', 'milling', 'coating');
  bindInput('operationType', 'milling', 'operationType');
  bindInput('strategyMode', 'milling', 'strategyMode');
  bindInput('radialEngagement', 'milling', 'radialEngagement');
  bindInput('axialDepth', 'milling', 'axialDepth');
  // drilling bindings
  bindInput('drill-toolDiameter', 'drilling', 'toolDiameter');
  bindInput('drill-toolMaterial', 'drilling', 'toolMaterial');
  bindInput('drill-coating', 'drilling', 'coating');
  bindInput('drill-operationType', 'drilling', 'drillOperationType');
  bindInput('drill-strategyMode', 'drilling', 'drillStrategyMode');
  bindInput('drill-holeDepth', 'drilling', 'holeDepth');
  bindInput('drill-pointAngle', 'drilling', 'pointAngle');
  // tapping bindings
  bindInput('tapMajorDiameter', 'tapping', 'tapMajorDiameter');
  bindInput('threadPitch', 'tapping', 'threadPitch');
  bindInput('tapMaterial', 'tapping', 'tapMaterial');
  bindInput('tappingStrategy', 'tapping', 'tappingStrategy');
  bindInput('threadEngagement', 'tapping', 'threadEngagement');
  bindInput('tap-holeDepth', 'tapping', 'holeDepth');

  document.addEventListener('gpm:unitchange', function () {
    applyUnitLabels();
    compute();
  });

  setMode('milling');
});
})(window);
